export default {
  errorsRootKey: 'aiInfinityRules',
  resource: 'analytics/ai-infinity/rules',
  actions: ['index', 'show', 'create', 'update', 'destroy']
}